<div class="select-container">
  <button class="export-button" #trigger (click)="openDropdown($event)">
    <img *ngIf="!loading" src="../../../assets/icons/cloud-download.svg" alt="New Service"
      class="new-service-button-icon" />
    {{ExportText}}
    <img *ngIf="loading" src="../../../assets/gifs/loading-spinner.gif" alt="loading" class="new-service-button-icon" />

  </button>

  <div class="download-menu" #dropdown *ngIf="DropdownOpen" [class.align-right]="alignRight"
    [class.align-left]="!alignRight">
    <h3 class="export-title">
      {{'CSV_EXPORT.0' | translate}}

    </h3>

    <div class="checkbox-container">
      <div class="checkbox-container-row" (click)="ExportFormat.ExportXlsx = !ExportFormat.ExportXlsx">
        <input type="radio" class="checkbox-square" [checked]="ExportFormat.ExportXlsx" />
        <span class="export-body-label">
          Excel (.xlsx)
        </span>
      </div>

      <div class="checkbox-container-row" style="margin-top: 5px;"
        (click)="ExportFormat.ExportCsv = !ExportFormat.ExportCsv">
        <input type="radio" class="checkbox-square" [checked]="ExportFormat.ExportCsv" />
        <span class="export-body-label">
          CSV (.csv)
        </span>
      </div>
    </div>

    <button type="button" class="button-green button-padding-3 button-gap" (click)="exportSelected()"
      [ngClass]="{'button-disable': !ExportFormat.ExportCsv && !ExportFormat.ExportXlsx}">
      <img src="assets/icons/download-Icon.svg" alt="" class="img-icon" />
      <span style="font-size: 14px;">{{'CSV_EXPORT.1' | translate}}</span>
    </button>
  </div>


</div>